import React from 'react';
import { CTA_LABEL, scrollToBuy } from '../utils/constants';
type CtaButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
const BASE = 'inline-flex w-full max-w-lg items-center justify-center rounded-full bg-cta px-5 py-3.5 text-center font-head text-base uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#1C6B33] transition-colors duration-150 ease-out hover:bg-cta-dark active:translate-y-[2px] active:shadow-[0_4px_0_0_#1C6B33] sm:px-8 sm:py-4 sm:text-xl';
export function CtaButton({
  label = CTA_LABEL,
  className = '',
  href
}: CtaButtonProps) {
  if (href) {
    return <a href={href} className={`${BASE} ${className}`} data-id="element-64" data-mp="109bxiy9rfp8x">
        {label}
      </a>;
  }
  return <button type="button" onClick={scrollToBuy} className={`${BASE} ${className}`} data-id="element-65" data-mp="vcbnyddpc4d2">
      {label}
    </button>;
}